import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../../styles.scss';

export default class AccordionItem extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func
  };

  static defaultProps = {
    isActive: false,
    onClick: () => {}
  };

  render() {
    return (
      <li className={`accordion-list__item ${this.props.isActive && 'active'}`}>
        <button onClick={this.onClick} className={`accordion-list__title ${this.props.isActive && 'active'}`}>{this.props.title}</button>
        <div className={`accordion-list__content ${this.props.isActive && 'active'}`}>
          {this.props.isActive && this.props.children}
        </div>
      </li>
    );
  }

  onClick = () => {
    this.props.onClick(this.props.id);
  };

}



// WEBPACK FOOTER //
// ./src/components/Accordion/components/AccordionItem/index.js